// Libs
import type { DateRange } from 'ui-components';
// App
import { TIME_PERIOD, TIME_PERIODS_CONFIG } from './filters.constants';
import { TimeFilters } from './filters.interfaces';

export const buildInitialFilters = (): TimeFilters => {
  const initialFilters: TimeFilters = {
    selectedTimePeriod: TIME_PERIOD.DAY,
    selectedFilterDate: new Date(),
    navigationDate: new Date(),
  };

  return initialFilters;
};

export const buildDurationStep = (timeFilter: TIME_PERIOD): Duration => {
  const duration: Duration = {
    days: (timeFilter == TIME_PERIOD.DAY && 1) || 0,
    weeks: (timeFilter == TIME_PERIOD.WEEK && 1) || 0,
    months: (timeFilter == TIME_PERIOD.MONTH && 1) || 0,
    years: (timeFilter == TIME_PERIOD.YEAR && 1) || 0,
  };

  return duration;
};

export const buildCustomPeriodFromSelectedPeriod = (filters: TimeFilters): DateRange => {
  const { startOfPeriodHandler, endOfPeriodHandler } = TIME_PERIODS_CONFIG(false)[filters.selectedTimePeriod];

  const customPeriod: DateRange = {
    start: startOfPeriodHandler(filters.selectedFilterDate),
    end: endOfPeriodHandler(filters.selectedFilterDate),
  };

  return customPeriod;
};
